var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueueEndService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C10.9494 8 9.90914 8.20693 8.93853 8.60896C7.96793 9.011 7.08601 9.60028 6.34315 10.3431C4.84285 11.8434 4 13.8783 4 16C4 18.1217 4.84285 20.1566 6.34315 21.6569C7.08601 22.3997 7.96793 22.989 8.93853 23.391C9.90914 23.7931 10.9494 24 12 24C14.1217 24 16.1566 23.1571 17.6569 21.6569C19.1571 20.1566 20 18.1217 20 16C20 14.9494 19.7931 13.9091 19.391 12.9385C18.989 11.9679 18.3997 11.086 17.6569 10.3431C16.914 9.60028 16.0321 9.011 15.0615 8.60896C14.0909 8.20693 13.0506 8 12 8ZM12 9.6C15.528 9.6 18.4 12.472 18.4 16C18.4 19.528 15.528 22.4 12 22.4C8.472 22.4 5.6 19.528 5.6 16C5.6 12.472 8.472 9.6 12 9.6ZM9.6 13.6V18.4H14.4V13.6",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueEndService);
export default __webpack_public_path__ + "static/media/queue_end-service.f08cd6a1e7526e1b4aebcad89ef8a7f1.svg";
export { ForwardRef as ReactComponent };